ACC.storefinder = {

	_autoload: [
		["init", $(".page-storefinderPage .js-store-finder").length != 0],
		["bindStoreChange", $(".page-storefinderPage .js-store-finder").length != 0],
		["bindSearch", $(".page-storefinderPage .js-store-finder").length != 0],
		["bindPagination", $(".page-storefinderPage").length != 0],
		["loadAgency", $(".page-storefinderPage #currentPOS_name").length != 0 && $(".page-storefinderPage #currentPOS_postalCode").length != 0],
		"savePreviousURL",
		"saveRememberAgency",
		"openStoreFinderPopinAOS",
		"bindStoreFinderPopinAOSEvents",
		"customScroll",
		"submitZipCode",
		"showAgenciesByRegion",
		"showAgenciesByRegionMobile",
		"encodeURLStore",
		"redirectListAgencies"
	],
	storeData:"",
	storeId:"",
	coords:{},
	storeSearchData:{},
	currentAgencyName:"",
	currentAgencyPostalCode:"",
	posPhoneNumber: "",
	popinAOS: "#popinAgencyOutOfScope",
	saveAgencyForm: "#confirmedAgencyChanging",
	popinAOSBtnClose: "#popinAgencyOutOfScope .btn_close",
	popinAOSBtnBack: "#popinAgencyOutOfScope .btn-secondary",
	popinAOSBtnConfirm: "#popinAgencyOutOfScope .btn-primary",
	fromFormSubmit: false,

	createListProductAOS: function (data,id){

		var item="";
		item+='<div class="storfinder__product">';
		if(data.imageURL){
			item+='<img src="'+data.imageURL+'" alt="'+data.imageText+'" />';
		}
		item+= '<p class="storfinder__product--name">'+data.name;
		if (data.amdsDimension) {
			item+= " - ";
			item += data.amdsDimension;
		}
		item+='</p>';
		item+='</div>';
		return item;
	},

	customScroll : function(){
		$("#confirmedAgencyChanging .product-rows").perfectScrollbar({
			useBothWheelAxes: false,
			suppressScrollX: true
		});
	},
	encodeURLStore : function() {

		$(document).on("click", ".obflinkstore", function (e) {
			var link = $(this).data('o');
			var linkDecoded = atob(link);
			var  url = decodeURI(linkDecoded); ///FR/fr/store-finder/details?code=FRCO

			window.location=  url;
		});
	},
	redirectListAgencies : function () {


		$(document).on("click", ".visibile_only_mobile", function (e) {

			var url = "/store-finder"

			window.location=  url;

		});

	},
	createListItemHtml: function (data, id){
		var item = "";

		item+='<li class="list__entry">';
		item+='<input type="hidden" id="isActivated" value="'+data.activated+'">';
		item+='<input type="radio" name="storeNamePost" value="'+data.displayName+'" id="store-filder-entry-'+id+'" class="js-store-finder-input" data-id="'+id+'">';
		item+='<label for="store-filder-entry-'+id+'" class="js-select-store-label">';
		item+='<span class="entry__info">';
		item+='<span class="entry__name">'+data.displayName+'</span>';
		item+='<span class="entry__address">'+data.line1+' '+data.line2+'</span>';
		item+='<span class="entry__cp">'+data.postalCode+'</span>';
		item+='<span class="entry__city">'+data.town+'</span>';
		item+='<span class="entry__details visible-xs">'+ showDetailsText +'</span>';
		item+='</span>';
		item+='<span class="entry__distance">';
		item+='<span>'+data.formattedDistance+'</span>';
		item+='</span>';
		item+='</label>';
		item+='</li>';
		return item;
	},

	refreshNavigation: function (){
		var listitems = "";
		data = ACC.storefinder.storeData

		if(data){
			var current_index = 0;
			
			for(i = 0;i < data["data"].length;i++){
				listitems += ACC.storefinder.createListItemHtml(data["data"][i], i);
				
				if(ACC.storefinder.currentAgencyName != "" && 
					ACC.storefinder.currentAgencyPostalCode != "" && 
					data["data"][i].name === ACC.storefinder.currentAgencyName && 
					data["data"][i].postalCode === ACC.storefinder.currentAgencyPostalCode) {
					current_index = i;
				}
			}

            $("#storeFinder .js-store-finder-navigation-list").html(listitems);
            
            ACC.storefinder.fromFormSubmit = true;
            $("#storeFinder .js-store-finder-navigation-list .js-select-store-label[for=store-filder-entry-"+current_index+"]").trigger('click');
		}

		ACC.storefinder.showTotalResultText(ACC.storefinder.storeData.total);
	},

	showTotalResultText: function(total) {
        $('#storeFinder .store_result_count').removeClass('hidden');

        var one   = $("#storeFinder .store_result_count .store_result_count_one"),
            all   = $("#storeFinder .store_result_count .store_result_count_all");

		if(total == 1) {
			one.removeClass('hidden');
			one.find('.numder').html(total);
			all.addClass('hidden');
		} else {
			all.removeClass('hidden');
			all.find('.numder').html(total);
			one.addClass('hidden');
		}
	},

	bindPagination:function ()
	{
		$(document).on("click",".js-store-finder-details-back,.back-to-list",function(e){
			e.preventDefault();

			$(".js-store-finder").removeClass("show-store");
			$(".store__finder--search,.store__finder--pagination").removeClass("hidden-xs");
			$(".js-store-finder-details-back").addClass("hidden-xs");

		})

		$(document).on("click",".js-store-finder-pager-prev",function(e){
			e.preventDefault();
			var page = ACC.storefinder.storeSearchData.page;
			ACC.storefinder.getStoreData(page-1)
			checkStatus(page-1);
		})

		$(document).on("click",".js-store-finder-pager-next",function(e){
			e.preventDefault();
			var page = ACC.storefinder.storeSearchData.page;
			ACC.storefinder.getStoreData(page+1)
			checkStatus(page+1);
		})

		function checkStatus(page){

			if(page==0){
				$(".js-store-finder-pager-prev").attr("disabled","disabled")
			}else{
				$(".js-store-finder-pager-prev").removeAttr("disabled");
			}

			if(page == Math.floor(ACC.storefinder.storeData.total/10)){
				$(".js-store-finder-pager-next").attr("disabled","disabled")
			}else{
				$(".js-store-finder-pager-next").removeAttr("disabled")
			}
		}

	},

	bindStoreChange:function()
	{
		$(document).on("change",".js-store-finder-input",function(e){
			e.preventDefault();
			
	        $('#deliveryPartnerDetails').html('');

			storeData = ACC.storefinder.storeData["data"];

			var storeId = $(this).data("id");
			var $ele = $(".js-store-finder-details");

			$.each(storeData[storeId],function(key,value){
				if(key=="image"){
					if(value!=""){
						$ele.find(".js-store-image").html('<img src="'+value+'" alt="" />');
					}else{
						$ele.find(".js-store-image").html('');
					}
				}else if(key=="productcode"){
					$ele.find(".js-store-productcode").val(value);
				}
				else if(key=="openings"){
					if(value!=""){
						var $oele = $ele.find(".store__finder--details-openings");
						var openings = "";
						var today = new Date();

						 $.each(value,function(key2,value2){
							openings += "<div ";
							//dayNames est le tableau des jours utilisé pour le datePicker, instancié dans javaScript.tag
							if(key2 == dayNames[today.getDay()]) {
								openings +="class='today'"
							}
							openings += ">";
						 	openings += "<span class='day-name'>"+key2+" </span>";
							openings += "<span class='day-details'>: &nbsp;";
							openings += "<span class='morning'>"+value2.split('_')[0]+"</span>";
							if(value2.split("_").length > 1) {
								openings += "<span class='afternoon'>"+ value2.split('_')[1] + "</span>";
							}
							openings += "</span>";
						 	openings += "</div>";
						 });

						 $oele.html(openings);

					}
				}
				else if(key=="specialOpenings"){}
				else if(key=="features"){
					var features="";
					$.each(value,function(key2,value2){
						features += "<li>"+value2+"</li>";
					});

					$ele.find(".js-store-"+key).html(features);

				}
				else if(key=="phone"){
					if(value != "") {
						$ele.find(".info__tel .phone_link").html(value);
						$ele.find(".info__tel .phone_link").attr("href","tel:"+value.trim());
						ACC.storefinder.posPhoneNumber = value;
						$('.disabled-agency-msg-phone').html(' ' + value + '.');
					} else {
						$ele.find(".info__tel .phone_link").html("");
					}
				}

				else if(key=="email"){
					if(value != "") {
						$ele.find(".info__email .mail_link").html(value);
						$ele.find(".info__email .mail_link").attr("href","mailto:"+value);
					} else {
						$ele.find(".info__email .mail_link").html("");
					}
				}

				else{
					if(value!=""){
						$ele.find(".js-store-"+key).html(value);
					}else{
						$ele.find(".js-store-"+key).html('');
					}
				}

				if(key == "name"){
					$('#pointOfServiceName').val(value);
				}
			});

			ACC.storefinder.storeId = storeData[storeId];
		})

        $(document).on("click","#storeFinder .js-select-store-label",function(e){
        	
        	if($(window).width() <= 640 && !ACC.storefinder.fromFormSubmit) {
				$(".js-store-finder").addClass("show-store");
				$(".store__finder--search,.store__finder--pagination").addClass("hidden-xs");
				$(".js-store-finder-details-back").removeClass("hidden-xs");
            }
			
			ACC.storefinder.fromFormSubmit = false;
        	
			if($(this).parent().find('#isActivated').val() == 'false') {
				$('.remember_agency_checkbox, .choose_agency').addClass('hidden');
				$('.disabled-agency-msg').removeClass('hidden');
			} else {
				$('.remember_agency_checkbox, .choose_agency').removeClass('hidden');
				$('.disabled-agency-msg').addClass('hidden');
			}
		})

		$(document).on("click",".js-back-to-storelist",function(e){
			$(".js-store-finder").removeClass("show-store");
		})
	},

	addDeliveryPartnerDetails : function(){
		var html = '';
		
		$.each(ACC.storefinder.storeData["data"][0],function(key,value){
			if(key == 'deliveryPartners'){
				for(i=0; i<value.length; i++){
					html += '<div class="block'+i+'" style="display: none;">';
					html += '<span class="name">'+value[i].displayName+'</span>';
					html += '<span class="address">'+value[i].phone+', '+value[i].line1+'</span>';
					html += '<span class="postal">'+value[i].postalCode+' '+value[i].town+'</span>';
					html += '</div>';
				}
			}
		});

		$('#deliveryPartnerDetails').append(html);
	},

	bindSearch:function(){
		$(document).on("click",'.js-store_finder_search', function(e){
			e.preventDefault();

			$("#storeFinder #storeFinderForm .js-store-finder-search-input").removeClass("error");
			$("#storeFinder #storeFinderForm .amds-select-option").removeClass("error");

			var q = $("#storeFinder .js-store-finder-search-input").val(),
				lat = null,
				long = null,
				isoCode= $("#storeFinder #codeCountry").val();

			//google tag manager

			/*window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event':'store_locator',
				'postal_code': q
			});
			});*/

			setTimeout(function() {
				if(navigator.geolocation && !$.isEmptyObject(ACC.storefinder.coords)) {
					lat = ACC.storefinder.coords.latitude;
					long = ACC.storefinder.coords.longitude;
				}

				if(q.length > 0){
					if(lat != null && long != null) {
						ACC.storefinder.getInitStoreData(q, lat, long,isoCode);
					} else {
						ACC.storefinder.getInitStoreData(q, null, null, isoCode);
					}
				} else if($("#currentPOS_postalCode").length != 0 && $("#currentPOS_postalCode").val() != "") {
					ACC.storefinder.currentAgencyPostalCode = q = $("#currentPOS_postalCode").val();

					if(lat != null && long != null) {
						ACC.storefinder.getInitStoreData(q, lat, long, isoCode);
					} else {
						ACC.storefinder.getInitStoreData(q, null, null, isoCode);
					}
				} else {
					if($(".js-storefinder-alert").length < 1) {
						var emptySearchMessage = $(".js-store_finder_search").data("searchEmpty")
						$(".js-store-finder").hide();
						$("#storeFinder #storeFinderForm .input-group").after('<div class="js-storefinder-alert alert alert-danger alert-dismissable amds-alert" ><button class="close" type="button" data-dismiss="alert" aria-hidden="true">×</button>' + emptySearchMessage + '</div>');
					}

					$("#storeFinder #storeFinderForm .js-store-finder-search-input").addClass("error");
					$("#storeFinder #storeFinderForm .amds-select-option").addClass("error");
				}
			}, 500);
		})


		$(".js-store-finder").hide();
		$(document).on("click",'#findStoresNearMe', function(e){
			e.preventDefault()
			ACC.storefinder.getInitStoreData(null,ACC.storefinder.coords.latitude,ACC.storefinder.coords.longitude);
		})
	},


	getStoreData: function(page){
		ACC.storefinder.storeSearchData.page = page;
		/*url= $(".js-store-finder").data("url");
		$.ajax({
			url: url,
			data: ACC.storefinder.storeSearchData,
			type: "get",
			success: function (response){
				try {
					$("#storeFinder #storeFinderForm .js-store-finder-search-input").removeClass("error");
					
					ACC.storefinder.storeData = $.parseJSON(response);

					$(".js-store-finder").show();

					ACC.storefinder.refreshNavigation();
					if(ACC.storefinder.storeData.total < 10){
						$(".js-store-finder-pager-next").attr("disabled","disabled");
					}
				} catch (e) {
					$(".js-store-finder").hide();

					if($(".js-storefinder-alert").length<1){
						var emptySearchMessage = $(".btn-primary").data("searchEmpty");
						$("#storeFinder #storeFinderForm .input-group").after('<div class="js-storefinder-alert alert alert-danger alert-dismissable amds-alert" ><button class="close" type="button" data-dismiss="alert" aria-hidden="true">×</button>' + emptySearchMessage + '</div>');
					} else {
						$(".alert").show();
					}
					$("#storeFinder #storeFinderForm .js-store-finder-search-input").addClass("error");
				}
			}
		});*/
	},

	getInitStoreData: function(q,latitude,longitude,isoCode){
		$(".alert").hide();
		data ={
			"q":"" ,
			"page":0
		}
		if(q != null){
			data.q = q;
		}

		if(latitude != null){
			data.latitude = latitude;
		}

		if(longitude != null){
			data.longitude = longitude;
		}
		if(isoCode != null){
			data.isoCode = isoCode;
		}
		ACC.storefinder.storeSearchData = data;
		ACC.storefinder.getStoreData(data.page);
		$(".js-store-finder-pager-prev").attr("disabled","disabled");
	},

	loadAgency: function() {
		ACC.storefinder.currentAgencyName = $(".page-storefinderPage #currentPOS_name").val();
	},

	savePreviousURL: function() {
		$(document).on('click', '.amds-header-store a', function() {
			$.cookie("storeFinderPreviousURL", window.location.href);
		});
	},

	saveRememberAgency: function() {
		$(document).on('change', '#remember_agency_checkbox', function() {
			if($(this).is(':checked')){
				$('#remember_agency_hidden').val(true);
			} else {
				$('#remember_agency_hidden').val(false);
			}
		});
	},

	submitZipCode: function(){
		$(document).on('submit', '#storeFinderForm', function() {
			var q = $(".js-store-finder-search-input").val();
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event':'store_locator',
				'postal_code': q
			});
		});
	},

	openStoreFinderPopinAOS: function() {
		$("#storeFinder .choose_agency").click(function (e) {
			e.preventDefault();
			agencyName=$("#pointOfServiceName").val();
			agencyDisplayName=$("#pointOfServiceDisplayName").val();
			url = $(this).attr("confirmAgencyChangeUrl");
			url += agencyName+"/checkCart";
			dataToSend="";


			$.ajax({
				url: url,
				data: dataToSend,
				type: "get",
				success: function (response){
					storeData = $.parseJSON(response);
					if(storeData.total>=1){
								var listitems = "";
								$(".product-rows").html('');
								if (data) {
									for (i = 0; i < storeData["data"].length; i++) {
										listitems += ACC.storefinder.createListProductAOS(storeData["data"][i], i);
									}
									$(".product-rows").append(listitems);
								}


						$("#popinAgencyOutOfScope #remember_agency_hidden").attr("value",$("#storeFinder #remember_agency_hidden").val());
						$("#popinAgencyOutOfScope #pointOfServiceName").attr("value",$("#storeFinder #pointOfServiceName").val());

						$(ACC.storefinder.popinAOS).modal({ keyboard: true});
						$("body").addClass("modal-store");

					}
					else{
						$("#saveAgencyForm").submit();
					}
				},
				error:function(error){
					console.log("An error occurred... The error code and message are: " + error.code + " / " + error.message);
				}
			});


		});

		$(".js-dismiss-store-change").click(function (e){
	            e.preventDefault();
		  });
	},

	closeStoreFinderPopinAOS: function() {
		$(ACC.storefinderPopin.popinStoreFinder).modal("toggle");

		if($('body').hasClass('page-clientNonAgenceRegisterPage')) {
			ACC.register.triggerSubmit = true;
			$(ACC.register.validateFormID).submit();
		}
	},

	bindStoreFinderPopinAOSEvents: function() {
		$(ACC.storefinder.popinAOS).on("hidden.bs.modal", function() {
			$("body").removeClass("modal-store");
		});

		$(document).on("click", ACC.storefinder.popinAOSBtnBack + "," +	ACC.storefinder.popinAOSBtnClose, function (e) {
			$(ACC.storefinder.popinAOS).modal("toggle");
		});
	},

	init:function(){
		$("#findStoresNearMe").attr("disabled","disabled");
		$('body').addClass('noGeolocation');
		
		if(navigator.geolocation){
			navigator.geolocation.getCurrentPosition(
				function (position){
					ACC.storefinder.coords = position.coords;
					$('#findStoresNearMe').removeAttr("disabled");
					$('body').removeClass('noGeolocation');
				},
				function (error)
				{
					console.log("An error occurred... The error code and message are: " + error.code + "/" + error.message);
				}
			);
		}

		if($.cookie("storeFinderPreviousURL") !== null) {
			$('#previousURL').val($.cookie("storeFinderPreviousURL") != "" ? $.cookie("storeFinderPreviousURL") : window.location.href);
		} else {
			$('#previousURL').val(window.location.href);
		}
	},

	showAgenciesByRegion:function()
        {

            $(document).on("click", "[id^=region_]", function (e) {
    //		$('[id^=region_]').click(function () {
                $('[id^=region_]').removeClass("hoverRegion");

                $(this).addClass("hoverRegion");

                var showw = $(this).data('o'); //SUD

                $('.region_selector span').html(showw);

                $("li.seo_context[data-region != '"+showw+"' ]" ).each(function( index ) {
                    $(this).hide() ;

                });

                $("li.seo_context[data-region = '"+showw+"' ]" ).each(function( index ) {
                    $(this).show() ;
                });

            });

        },
    showAgenciesByRegionMobile : function ()
            {
                $(document).on("click", "[id^=langCountryMenuSeo]", function (e) {

                    if ($('#langCountryMenuSeo').hasClass('flechDes'))
                    {

                        $('[id^=langCountryMenuSeo]').removeClass("flechDes");
                        $('[id^=langCountryMenuSeo]').addClass("flechAsc");

                    }
                });

                $(document).on("click", "[id^=regionmobile_]", function (e) {


                    $('[id^=langCountryMenuSeo]').removeClass("flechAsc");

                    $('[id^=langCountryMenuSeo]').addClass("flechDes");


                    $('[id^=regionmobile_]').removeClass("hoverRegion");
                    $(this).addClass("hoverRegion");


                    var showw = $(this).data('o'); //SUD

                    $('.region_selector span').html(showw);

                    $("li.seo_context[data-region != '"+showw+"' ]" ).each(function( index ) {
                        $(this).hide() ;

                    });

                    $("li.seo_context[data-region = '"+showw+"' ]" ).each(function( index ) {
                        $(this).show() ;
                    });


                    if(	$("li.seo_context[data-region = '"+showw+"' ]" ).length < 5 )
                    {

                        $('[id^=scroller]').removeClass("scroller");
                    }

                });
            }
};
